import { Card } from "antd";
import ActivityLoaderMintbox from "Components/ActivityLoaderMintbox";
import BreadCrumbs from "Components/BreadCrumbs";
import { getKnowledgeBaseData } from "Components/getKnowledgeBaseData";
import Head from "Layout/Head";
import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router";
import { Link } from "react-router-dom";
import { Col, Row } from "reactstrap";

const CategoryPage = () => {
    const params = useParams();
    const [loading, setLoading] = useState(true);
    const [category, setCategory] = useState({});
    const [subCategories, setSubCategories] = useState([]);
    const navigate = useNavigate();

    const loadData = async () => {
        let res = await getKnowledgeBaseData();
        if (res.type) {
            setCategory(res.categories?.filter(item => item?.Category?.toLowerCase().split(' ').join('_') === params.category)?.[0] || {});
            setSubCategories(res.subCategories?.filter(item => item?.Category?.toLowerCase().split(' ').join('_') === params.category) || []);
        }
        setLoading(false);
    }

    useEffect(() => {
        window.scrollTo(0, 0);
        loadData();
    }, [params]);

    if (loading) {
        return (
            <div className='flex-grow-1 mt-5'>
                <ActivityLoaderMintbox />
            </div>
        )
    }
    return (
        <React.Fragment>
            <Head title={category.Category || "Loading"} />
            <div className='kbMidContainer'>
                <h2>
                    {category.Category}
                </h2>
                <div className='textMD margin20Bottom'>
                    {category.Description}
                </div>
                <Row lg={3} sm={2} xs={1} >
                    {subCategories.map((item) => (
                        <Col key={item.UID} className='margin20Bottom'>
                            <Card style={{ height: "100%" }} hoverable={true}
                                onClick={() => navigate(`${item.FirstBlog}`)} bordered={false}>
                                <div className='d-flex align-items-center flex-column' style={{ gap: "10px", padding: "1.6rem 0px" }}>
                                    <div style={{ background: "var(--dark1)", padding: "2rem", borderRadius: "var(--borderRadius)" }}>
                                    </div>
                                    <div className="fontH1" style={{ textTransform: "capitalize" }}>
                                        <Link to={`${item.FirstBlog}`} className='cardHeader textLG'>
                                            {item.SubCategory}
                                        </Link>
                                    </div>
                                </div>
                            </Card>
                        </Col>
                    ))}
                </Row>
            </div>
        </React.Fragment>
    )
}

export default CategoryPage;